var compareproducts
jQuery(document).ready(function(){
  var compareproducts = getItemFromLocalStorage('compareproducts');
  if(compareproducts != null && compareproducts != ''){
    compareproducts = JSON.parse(compareproducts);
    for (const productId in compareproducts) {
      jQuery('#compare_chkbox_'+productId).prop('checked', true);
    }
  }else{
    compareproducts = null;
  }

  jQuery(document).on('click','.compare-chkbox',function(){
    var compareproducts = getItemFromLocalStorage('compareproducts');

    if(compareproducts == null || compareproducts == ''){
      compareproducts = {};
    }else{
      compareproducts = JSON.parse(compareproducts);
    } 

    if(jQuery(this).prop('checked')){
      compareproducts[jQuery(this).attr('data-product-id')] = jQuery(this).val();
    }else{
      delete compareproducts[jQuery(this).attr('data-product-id')];
    }
    setItemFromLocalStorage('compareproducts', JSON.stringify(compareproducts));
  });
});	

function getItemFromLocalStorage(key){
  return localStorage.getItem(key);
}
function setItemFromLocalStorage(key, value){
  localStorage.setItem(key, value);
}